import { Wind, Leaf, Droplets, Trees, ChevronDown, Info } from 'lucide-react';
import { useState } from 'react';
import PngIcon from '../../General/PngIcon';
import ServiceBenefitsModal from './ServiceBenefitsModal';

import aeration from '../../../assets/aca_service_icons/aeration.png';
import double_pass_aeration from '../../../assets/aca_service_icons/double_pass_aeration.png'
import fertilization_feed_only from '../../../assets/aca_service_icons/fertilization.png'
import weed_pre from '../../../assets/aca_service_icons/pre_emergent_weed_control.png'
import weed_post from '../../../assets/aca_service_icons/post_emergent_weed_control.png'
import revive  from'../../../assets/aca_service_icons/revive.png'
import overseed from '../../../assets/aca_service_icons/overseeding.png'
import sprinkler_activation from '../../../assets/aca_service_icons/sprinkler_activation.png'
import sprinkler_winterization from '../../../assets/aca_service_icons/sprinkler_winterization.png'
import sprinkler_audit from '../../../assets/aca_service_icons/sprinkler_audit.png'
import yard_cleanup from '../../../assets/aca_service_icons/yard_cleanup.png'
import power_rake from '../../../assets/aca_service_icons/power_raking.png'
import mosquito_control from '../../../assets/aca_service_icons/mosquito_control.png'


const iconMap = {
    Wind,
    Leaf,
    Droplets,
    Trees,
    aeration:    (props) => <PngIcon src={aeration} {...props} />,
    double_pass_aeration:    (props) => <PngIcon src={double_pass_aeration} {...props} />,
    fertilization_feed_only:    (props) => <PngIcon src={fertilization_feed_only} {...props} />,
    weed_pre:    (props) => <PngIcon src={weed_pre} {...props} />,
    weed_post:    (props) => <PngIcon src={weed_post} {...props} />,
    revive:    (props) => <PngIcon src={revive} {...props} />,
    overseed:    (props) => <PngIcon src={overseed} {...props} />,
    sprinkler_activation:    (props) => <PngIcon src={sprinkler_activation} {...props} />,
    sprinkler_winterization:    (props) => <PngIcon src={sprinkler_winterization} {...props} />,
    sprinkler_audit:    (props) => <PngIcon src={sprinkler_audit} {...props} />,
    yard_cleanup:    (props) => <PngIcon src={yard_cleanup} {...props} />,
    power_rake:    (props) => <PngIcon src={power_rake} {...props} />,
    mosquito_control: (props) => <PngIcon src={mosquito_control} {...props} />,
  };

  // const newIconMap = [
  //   {
  //     iconName: 'Wind',
  //     component: <PngIcon src={aeration} size={24} />
  //   }
  // ]

export default function ServiceCard({
    service,
    handleServiceToggle,
    handleTierChange,
    categoryDateAvailable
}) {
    const getPriceDisplay = (service) => {
        if (service.tiers) {
          const tier = service.tiers.find(tier => tier.is_selected)
          return tier ? `$${tier.price}` : `From $${service.tiers[0].price}`;
        }
        if (service.pricing) {
          return `$${service.pricing.fullYard}`;
        }
        if (service.price) {
          return `$${service.price}`;
        }
        return null;
      };
      
    const Icon = iconMap[service.icon] || Wind;
    const priceDisplay = getPriceDisplay(service);
    const hasTiers = !!service.tiers;
    const [showBenefits, setShowBenefits] = useState(false);
    const hasBenefits = !!(service.benefits_copy || service.benefits_video);

    return (
      <div className="relative group">
        {!categoryDateAvailable && (
          <div className="absolute inset-0 z-10 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
            <span className="bg-gray-800 text-white text-xs font-medium px-3 py-1.5 rounded-lg shadow-lg">
              No availability for this service
            </span>
          </div>
        )}
        {hasBenefits && (
          <ServiceBenefitsModal
            isOpen={showBenefits}
            onClose={() => setShowBenefits(false)}
            title={service.name}
            benefitsCopy={service.benefits_copy}
            videoId={service.benefits_video}
          />
        )}
        <div
            onClick={() => categoryDateAvailable && handleServiceToggle(service)}
            className={
              `p-6 rounded-lg border-2 transition-all duration-200 h-full
                ${!categoryDateAvailable
                  ? "opacity-50 cursor-not-allowed grayscale"
                  : "cursor-pointer hover:border-green-500 hover:shadow-lg hover:scale-[1.02]"
                }
                ${service.is_selected ? "bg-green-50 border-green-500 shadow-md" : "bg-white border-gray-200"}`
            }
        >
            <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-3">
                    <input
                        type="checkbox"
                        checked={service.is_selected}
                        onChange={() => handleServiceToggle(service)}
                        className="w-5 h-5 text-green-600 border-gray-300 rounded focus:ring-green-500"
                        onClick={(e) => e.stopPropagation()}
                        disabled={!categoryDateAvailable}
                    />
                    {hasBenefits && (
                        <button
                            type="button"
                            onClick={(e) => {
                                e.stopPropagation();
                                setShowBenefits(true);
                            }}
                            className="p-1 rounded-full bg-gray-100 text-gray-400 hover:!bg-green-100 hover:!text-green-600 group-hover:bg-green-100 group-hover:text-green-600 group-hover:scale-110 transition-all duration-200"
                            aria-label={`Learn more about ${service.name}`}
                        >
                            <Info className="w-4 h-4" />
                        </button>
                    )}
                </div>
                    {priceDisplay && (
                        <span className={
                            `text-sm font-semibold
                            ${service.is_selected ? "text-green-700" : "text-gray-600"}`
                        }>
                          {priceDisplay}
                        </span>
                    )}
            </div>
            <Icon className={`w-20 h-20
                        ${service.is_selected ? "text-green-700" : "text-green-600"}`
                    }/>
            <div>
                <h4 className={`font-semibold text-lg
                    ${service.is_selected ? "text-green-800" : "text-gray-800"}`
                    }>
                    {service.name}
                </h4>
                    <p className={`text-sm mt-1 ${service.is_selected ? "text-green-700" : "text-gray-600"}`}>
                        {service.description}
                    </p>
                    {hasTiers && service.is_selected && (
                        <div className="mt-3 relative">
                          <select
                            value={service.tiers.find(tier => tier.is_selected)?.id || ''}
                            onChange={(e) => {
                              e.stopPropagation();
                              handleTierChange(service, e.target.value);
                            }}
                            onClick={(e) => e.stopPropagation()}
                            className="w-full px-3 py-2 pr-8 border border-green-300 rounded-lg bg-white text-sm font-medium text-gray-800 focus:ring-2 focus:ring-green-500 focus:border-transparent appearance-none"
                          >
                            {service.tiers.map((tier) => (
                              <option key={tier.id} value={tier.id}>
                                {tier.label} — ${tier.price}
                              </option>
                            ))}
                          </select>
                          <ChevronDown className="absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500 pointer-events-none" />
                        </div>
                    )}
            </div>
        </div>
      </div>
    )
}